import React from 'react'
import { InputAdornment, TextField } from '@material-ui/core'
import { useField } from 'formik'
import NumberFormat from 'react-number-format';

type TextFieldIconAdornmentProps = {
  disabled?: boolean
  disableTypography?: boolean
  label?: string
  name: string
  placeholder?: string
  iconAdornmentPosition: 'start' | 'end'
  iconAdornmentContent?: any
  style?: {}
  type?: string
  onChange?: (e) => void
}

/**
 * @author JE 03-31-20
 * @description Creates an object that positions (at the beginning or at the end) an icon relative to an input
 */
function createIconAdornmentObject(disableTypography, iconAdornmentPosition, iconAdornmentContent) {
  const inputObject = {}
  inputObject[`${iconAdornmentPosition}Adornment`] = (
    <InputAdornment disableTypography={disableTypography} position={iconAdornmentPosition}>
      {iconAdornmentContent}
    </InputAdornment>
  )
  return inputObject
}

const FormattedCurrency = (props: any) => {
  const { inputRef, onChange, ...other } = props;

  return (
    <InputAdornment position='start' style={{ paddingLeft: '14px' }}>
      {'$'}
      <NumberFormat
        {...other}
        getInputRef={inputRef}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
        thousandSeparator
        isNumericString
      />
    </InputAdornment>
  );

}

const ValidatedInputAdornmentTextField = (props: TextFieldIconAdornmentProps) => {
  const {
    disableTypography = true,
    disabled,
    iconAdornmentPosition,
    iconAdornmentContent,
    label,
    name,
    placeholder,
    type,
    style,
    onChange,
  } = props
  const [field, meta] = useField(name)

  const currentOnChange = onChange ? onChange : field.onChange

  const error = !!(meta.error && meta.touched)
  const helperText = error ? meta.error : null


  if (iconAdornmentContent === '$') {
    return (
      <TextField
        error={error}
        helperText={helperText}
        label={label}
        name={name}
        onBlur={field.onBlur}
        onChange={currentOnChange}
        style={style}
        value={meta.value}
        variant="outlined"
        InputProps={{
          inputComponent: FormattedCurrency,
        }}
      />
    )
  }

  const inputProps = createIconAdornmentObject(disableTypography, iconAdornmentPosition, iconAdornmentContent)

  return (
    <TextField
      label={label}
      error={error}
      name={name}
      onChange={currentOnChange}
      onBlur={field.onBlur}
      InputProps={inputProps}
      type={type}
      style={style}
      placeholder={placeholder}
      disabled={disabled}
      variant="outlined"
      helperText={helperText}
      value={meta.value}
    />
  )
}

export default ValidatedInputAdornmentTextField
